import { Button, Card, Form, Spin, } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import {
    PlusOutlined,
    SaveOutlined,
    CloseOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";

import MediTable from "components/Custom";
import {
    getGopKhachHangNcc,
    gopKhachHangNcc,
    searchKhachHangNCC,
} from "store/slices/khachhangSlice";
import { isEmpty } from "lodash";
import EditableCell from "components/EditableCell";

export const initHoSo = {
    action: "initial",
    isRequired: true,
};
const GopNCCKH = ({ congTyId, CongTyDetail }) => {
    const dispatch = useDispatch();
    const { loading, searchKhachHangNCCList, gopKhachHangNccList } = useSelector(
        (state) => state.khachhang
    );
    const [form] = Form.useForm();
    const [editingKey, setEditingKey] = useState("");


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const isEditing = (record) =>
        record.action === "initial"
            ? record.action === editingKey
            : record.id === editingKey;

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const edit = (record) => {
        form.setFieldsValue({
            tenCongTy: null,
            ...record,
        });
        setEditingKey(record.action === "initial" ? record.action : record.id);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const save = async (key) => {
        try {
            const row = await form.validateFields();
            // const newData = KhachHangNccChiTietList.slice(0);
            // const index = newData.findIndex((item) =>
            //     item.id ? item.id === key : item.action === key
            // );
            const payload = {
                den: congTyId,
                ...row,
                onSuccess: () => {
                    dispatch(getGopKhachHangNcc(congTyId));
                    dispatch(searchKhachHangNCC({}));
                    setEditingKey("");
                },
            };

            dispatch(gopKhachHangNcc(payload));
        } catch (error) { }
    };


    useEffect(() => {
        if (isEmpty(congTyId)) return;
        dispatch(getGopKhachHangNcc(congTyId));

    }, [congTyId, dispatch]);

    const tableColumns = useMemo(
        () => [
            {
                title: "STT",
                align: "center",
                render: (_, __, index) => index + 1,
                width: 60,
            },
            {
                title: "Mã công ty",
                dataIndex: "maCongTy",
                width: 120,
            },
            {
                title: "Tên công ty",
                dataIndex: "tu",
                editable: true,
                inputType: "select",
                //mode: "multiple",
                options:
                    searchKhachHangNCCList?.filter(f => f.id !== congTyId)?.map((m) => ({ value: m.id, label: `[${m.maSoThue}] - ${m.tenCongTy}` }))
                ,
                render: (r, x) => x.tenCongTy,
            },
            {
                title: "Mã số thuế",
                dataIndex: "maSoThue",
                width: 130,
            },

            {
                fixed: "right",
                align: "center",
                width: 120,
                render: (_, record, index) => {
                    const editable = isEditing(record);
                    return editable ? (
                        <>
                            <Button
                                onClick={() => save(record?.id || "initial")}
                                className="mr-2"
                                icon={<SaveOutlined />}
                                shape="circle"
                            />
                            <Button
                                onClick={() => setEditingKey("")}
                                className="mr-2"
                                icon={<CloseOutlined />}
                                shape="circle"
                            />
                        </>
                    ) : (
                        <>
                            <Button
                                title={"Thêm thông tin"}
                                onClick={() => edit(record)}
                                className="mr-2"
                                icon={
                                    <PlusOutlined />
                                }
                                shape="circle"
                            />
                            {/* {record.id && (
                                <>
                                    <Popconfirm
                                        title="Bạn có muốn xóa không?"
                                        placement="topLeft"
                                        onConfirm={() => {
                                            dispatch(
                                                deleteKhachHangNCCChiTiet({
                                                    id: record.id,
                                                    onSuccess: () => {
                                                        dispatch(getKhachHangNCCChiTiet(congTyId));
                                                    },
                                                })
                                            );
                                        }}
                                    >
                                        <Button
                                            title={"Xóa thông tin"}
                                            disabled={!allowView(PermitValue.xoa)}
                                            className="mr-2"
                                            icon={<DeleteOutlined type="primary" />}
                                            shape="circle"
                                        />
                                    </Popconfirm>
                                </>
                            )} */}
                        </>
                    );
                },
            },
        ],
        [congTyId, edit, isEditing, save, searchKhachHangNCCList]
    );

    const mergedColumns = tableColumns.map((col) => {
        if (!col.editable) {
            return col;
        }

        return {
            ...col,
            onCell: (record) => ({
                record,
                title: col.title,
                dataIndex: col.dataIndex,
                editing: isEditing(record),
                inputType: col?.inputType,
                isRequired: col?.isRequired,
                mode: col?.mode,

                options: col?.options,
            }),
        };
    });

    return (
        <Card>
            <h3>Danh sách gộp với mã {`[${CongTyDetail?.maCongTy}]`}</h3>
            <Spin tip="Đang tải..." spinning={loading}>
                <Form form={form} component={false}>
                    <MediTable
                        components={{
                            body: {
                                cell: EditableCell,
                            },
                        }}
                        tableColumns={mergedColumns}
                        dataSource={[{ action: "initial" }].concat(gopKhachHangNccList)}
                        scroll={{ x: "max-content" }}
                        rowKey={(item) => item?.id}
                    />
                </Form>
            </Spin>
        </Card>
    );
};

export default GopNCCKH;
